export enum ExamType {
  INITIAL = "INITIAL",
  RENEW = "RENEW",
}
